import { appState } from '@/store/appState'
import { getCurrentUserLocation } from '@/lib/geolocation'
import { POLL_MS } from '@/config/constants'
import { ENABLE_MOCK_POSITION } from '@/config/flags'

/* Port of custom_code/actions/start_geting_current_user_location.dart (sic).
 *
 * _instantTimer is a MODULE-LEVEL global — one timer for the whole app,
 * surviving page unmounts. The ONLY canceller is the "Go back" button
 * (stop=true); Tracking's dispose never cancels it. Kept faithfully.
 *
 * Flow (stop=false):
 *  1. cancel any existing timer;
 *  2. one-shot fix -> appState.myPosition (SILENT write);
 *  3. if fix is the (0,0) sentinel -> update() (publish) -> false;
 *  4. release builds only (!kDebugMode): start the 10 s periodic timer with
 *     an immediate first tick scheduled as a microtask (InstantTimer
 *     semantics) — each tick re-fixes and DOES publish;
 *  5. true.
 *
 * ENABLE_MOCK_POSITION (dev) maps to kDebugMode: timer suppressed. */

let instantTimer: ReturnType<typeof setInterval> | null = null

export async function startGetingCurrentUserLocation(stop: boolean): Promise<boolean> {
  if (stop) {
    if (instantTimer) clearInterval(instantTimer)
    instantTimer = null
    return true
  }

  if (instantTimer) clearInterval(instantTimer)
  instantTimer = null

  const v = await getCurrentUserLocation({ lat: 0, lng: 0 })
  appState.myPosition = v // silent — no publish
  if (v.lat === 0 && v.lng === 0) {
    appState.update()
    return false
  }

  if (!ENABLE_MOCK_POSITION) {
    const tick = async () => {
      const p = await getCurrentUserLocation({ lat: 0, lng: 0 })
      appState.myPosition = p
      appState.update()
    }
    instantTimer = setInterval(tick, POLL_MS)
    // InstantTimer.startImmediately: first tick as a microtask-ish delay,
    // AFTER this function has already returned.
    setTimeout(tick, 0)
  }
  return true
}
